import Sidebar from "components/Sidebar";
import React from "react";

const TenderStatistics = () => {
	return (
		<main className="workspace">
			<Sidebar />
			<div className="workspace__content">
				<section className="workspace__wrapper">
					<h3 className="workspace__title workspace__page-title">
						Тендерная статистика
					</h3>
				</section>
			</div>
		</main>
	);
};

export default TenderStatistics;
